export default __webpack_public_path__ + "static/software-3-731ec7c4ee8cda1a2f91b98a54d0d982.webp";